import { FullBooking } from '@alluradirect/react';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import { Typography } from '@mui/material';
import { LabelAndValue } from 'components/core/LabelAndValue/LabelAndValue';
import { lengthOfStayDiscount } from 'components/views/pages/Checkout/CheckoutSummary/helpers';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import { formatCanadianCurrency } from 'helpers/currencyHelpers';

interface Props {
  isOpen: boolean;
  close: () => void;
  checkoutData: BookingCheckoutResponse | undefined;
  bookingData: FullBooking | undefined;
  isLastStep: boolean;
  currency_code: string;
  currency_multiplier: number;
}

export const CheckoutSummaryDiscountsDialog = ({ isOpen, close, checkoutData, bookingData, isLastStep, currency_code, currency_multiplier }: Props) => {
  const losDiscount = lengthOfStayDiscount({ checkoutData, bookingData, isLastStep });

  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle="Discounts"
      useIsXs={false}
      maxWidth="xs"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2">This property offers a reduced nightly rate for longer duration stays.  Your dates are eligible for this discount.</Typography>
          <AppDivider />
        </Grid>

        <Grid item xs={12}>
          <LabelAndValue
            label={'Length of Stay Discount'}
            value={`-${formatCanadianCurrency(losDiscount, { currency_code, currency_multiplier })}`}
            variant="accounting"
            fontWeight="500"
          />
        </Grid>
      </Grid>
    </ConfirmationDialog>
  );
};
